import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ServiceTaskHistory } from './service-task-history';
export { ServiceTaskHistory };
import { serviceTaskHistorySchema } from '@schemas/business-objects/service-task-history';
import { ServiceTaskFormGroup } from './service-task-form-group';

export class ServiceTaskHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    serviceTaskId: SchemaFormControl;
    serviceTask: ServiceTaskFormGroup;
  };

  declare value: Partial<ServiceTaskHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(serviceTaskHistorySchema, ServiceTaskHistory, data, options);
  }

  get object(): ServiceTaskHistory {
    return new ServiceTaskHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'serviceTask':
        return new ServiceTaskFormGroup();
      default:
        return undefined;
    }
  }
}

export class ServiceTaskHistoryFormArray extends PersistedFormArray {
  readonly entityName = 'ServiceTaskHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(serviceTaskHistorySchema, ServiceTaskHistory, options);
  }

  protected override createItemGroup() {
    return new ServiceTaskHistoryFormGroup();
  }

  get array(): ServiceTaskHistory[] {
    return this.controls.map(
      (group: ServiceTaskHistoryFormGroup) => group.object,
    );
  }
}

export class ServiceTaskHistoryPersistedArray extends PersistedArray<ServiceTaskHistory> {
  readonly entityName = 'ServiceTaskHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ServiceTaskHistory, options);
  }
}
